import { useMutation, useQueryClient } from "@tanstack/react-query"
import { rejectRfqAdminToSeller } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useRejectRfqAdminToSeller() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => rejectRfqAdminToSeller(id, accessToken!),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ["seller-rfqs"] })
      queryClient.invalidateQueries({ queryKey: ["admin-seller-rfq-detail", id] })
    },
  })
}
